import { useTranslation } from "react-i18next";

export function useTranslateRouteName() {
  const { t } = useTranslation();

  function translateRouteName(pathname: string) {
    if (pathname === "/") {
      return t("storesOverview");
    }

    if (pathname.includes("/settings")) {
      return t("settings");
    }

    if (pathname.includes("/inventory")) {
      return t("inventory");
    }

    if (pathname.includes("/report")) {
      return t("report");
    }

    if (pathname.includes("/profile")) {
      return t("profile");
    }
  }

  return { translateRouteName };
}
